import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {InputComponent} from "../../../shared-module/components/input/input.component";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";

import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {
  PasswordValidationDisplayComponent
} from "../../../shared-module/components/password-validation-display/password-validation-display.component";
import {containsNumberValidator} from "../../../shared-module/validators/contains-number.validator";
import {containsUppercaseValidator} from "../../../shared-module/validators/contains-uppercase.validator";
import {
  containsSpecialCharacterValidator
} from "../../../shared-module/validators/contains-special-character.validator";
import {containsLowercaseValidator} from "../../../shared-module/validators/contains-lowercase.validator";
import {matchesOtherControlValidator} from "../../../shared-module/validators/matches-other-control.validator";
import {distinctUntilChanged, Subscription} from "rxjs";
import ModalService from "../../../shared-module/services/modal.service";
import {
  PasswordResetSuccessModalComponent
} from "../../components/password-reset-success-modal/password-reset-success-modal.component";

@Component({
    selector: 'app-password-reset',
    imports: [
    ButtonComponent,
    InputComponent,
    RouterLink,
    PasswordValidationDisplayComponent,
    ReactiveFormsModule
],
    templateUrl: './password-reset.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './password-reset.component.scss'
})
export class PasswordResetComponent {
  private readonly modalService: ModalService = inject(ModalService);
  private readonly http: HttpClient = inject(HttpClient);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly router: Router = inject(Router);

  private token: string = '';
  private email: string = '';
  public reason: string;
  private modalSubscription: Subscription | null = null;

  public form: FormGroup = new FormGroup(
    {
      password: new FormControl("", [Validators.required,
        containsNumberValidator,
        containsUppercaseValidator,
        containsSpecialCharacterValidator,
        containsLowercaseValidator,
        matchesOtherControlValidator('confirm_password'),
        Validators.minLength(8),
      ]),
      confirm_password: new FormControl("", [Validators.required, matchesOtherControlValidator('password')]),
    }
  );

  public constructor() {
    this.token = this.route.snapshot.queryParamMap.get('token') ?? '';
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
    this.reason = this.route.snapshot.queryParamMap.get('reason') ?? '';

    this.form.controls['password'].valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.form.controls['password'].updateValueAndValidity();
      this.form.controls['confirm_password'].updateValueAndValidity();
    });

    this.form.controls['confirm_password'].valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.form.controls['password'].updateValueAndValidity();
      this.form.controls['confirm_password'].updateValueAndValidity();
    });
  }

  public submit(): void {
    if (this.form.invalid) {
      return;
    }
    this.http.post('/auth/reset', {
      password: this.form.get('password')?.value,
      confirm_password: this.form.get('confirm_password')?.value,
      token: this.token,
      email: this.email
    }).subscribe(() => {
      this.openPasswordResetSuccessModal();
    });
  }

  protected openPasswordResetSuccessModal(): void {
    this.modalSubscription = this.modalService.open(
      PasswordResetSuccessModalComponent,
      null,
      {
        title: 'Wachtwoord reset succesvol',
        dismissOnBackdropClick: true,
        showCloseButton: true,
        showBackdrop: true,
        width: '550px',
      }
    ).subscribe(() => {
      this.modalSubscription?.unsubscribe();
      this.modalSubscription = null;

      this.router.navigate(['/login']);
    });
  }
}
